import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export const PublishIcon: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 681.07 695.21"
    width={size}
    height={size}
    {...props}
  >
    <defs>
      <style>
        {`.publish-cls-1{fill:#b8cec1}.publish-cls-2{fill:#c7dfd1}.publish-cls-3{fill:#a9c4b5}.publish-cls-4{fill:#24588c}.publish-cls-5{fill:#75a28b}.publish-cls-6{fill:#8eb49f}`}
      </style>
    </defs>
    <g>
      <path className="publish-cls-5" d="m253.63,109.14H89.35c-6.23,0-11.26-5.03-11.26-11.26v-8.49c0-6.23,5.03-11.26,11.26-11.26h164.32c6.23,0,11.26,5.03,11.26,11.26v8.49c0,6.18-5.08,11.26-11.3,11.26Z"/>
      <path className="publish-cls-6" d="m264.85,159.16c0-.17.04-.34.04-.51v-8.49c0-6.23-5.03-11.26-11.26-11.26H89.35c-6.23,0-11.26,5.03-11.26,11.26v8.49c0,6.23,5.03,11.26,11.26,11.26h162.75c4.18-3.67,8.44-7.25,12.75-10.75Z"/>
      <path className="publish-cls-3" d="m222.11,199.68H89.35c-6.23,0-11.26,5.03-11.26,11.26v8.49c0,6.23,5.03,11.26,11.26,11.26h108.11c7.68-10.79,15.87-21.2,24.65-31.01Z"/>
      <path className="publish-cls-1" d="m178.48,260.45h-89.13c-6.23,0-11.26,5.03-11.26,11.26v8.49c0,6.23,5.03,11.26,11.26,11.26h73.48c4.73-10.62,9.94-20.98,15.65-31.01Z"/>
      <path className="publish-cls-2" d="m151.19,321.23h-61.84c-6.23,0-11.26,5.03-11.26,11.26v8.49c0,6.23,5.03,11.26,11.26,11.26h52.84c2.52-10.53,5.54-20.86,9-31.01Z"/>
      <path className="publish-cls-4" d="m561.55,135.07l-69.6-36.46c-5.12-2.69-11.26,1.02-11.26,6.82v14.93c-156.26,2.6-284.68,118.95-306.21,269.88H38.51V40.22h267.19v90.63c12.37-7.34,25.25-13.95,38.51-19.79V32.03c0-17.7-14.33-32.03-32.03-32.03H32.03C14.33,0,0,14.33,0,32.03v366.26c0,17.7,14.33,32.03,32.03,32.03h179.98c2.47-147.44,121.33-266.47,268.73-269.28v16.63c0,5.76,6.1,9.47,11.22,6.82l69.6-35.87c5.5-2.77,5.5-10.7,0-13.56Z"/>
    </g>
    <g>
      <path className="publish-cls-4" d="m471.24,226.35c-115.89,0-209.83,93.94-209.83,209.83,0,96.85,65.64,178.33,154.84,202.5v-41.45c-66.99-22.87-115.19-86.31-115.19-161.04,0-93.99,76.19-170.18,170.18-170.18s170.18,76.19,170.18,170.18c0,74.74-48.2,138.17-115.19,161.04v41.45c89.2-24.17,154.84-105.65,154.84-202.5,0-115.89-93.94-209.83-209.83-209.83Z"/>
      <polygon className="publish-cls-5" points="565.68 473.54 471.24 352.23 376.81 473.54 416.25 473.54 440.85 473.54 440.85 603.6 440.85 643.79 440.85 695.21 501.63 695.21 501.63 643.79 501.63 603.6 501.63 473.54 526.23 473.54 565.68 473.54"/>
    </g>
  </svg>
);

export const WebReviewIcon: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 360 232.67"
    width={size}
    height={size}
    {...props}
  >
    <defs>
      <linearGradient id="webrev-gradient" x1="0" y1="180" x2="360" y2="180" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#68a3ce', stopOpacity: 1 }} />
        <stop offset="1" style={{ stopColor: '#4982ac', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g transform="translate(0,-63.67)">
      <path
        d="m 360,222.44 c 0,-40.82 -33.09,-73.9 -73.9,-73.9 -10.72,0 -20.91,2.29 -30.11,6.4 -2.39,-50.81 -44.34,-91.27 -95.74,-91.27 -49.41,0 -90.09,37.39 -95.29,85.42 C 28.36,153.49 0,184.65 0,222.44 c 0,40.82 33.09,73.9 73.9,73.9 h 218.05 v -0.23 C 330.03,293.13 360,261.28 360,222.44 Z"
        style={{ fill: 'url(#webrev-gradient)' }}
      />
      <path
        d="m 256.61,249.42 -35.88,-36.04 c -1.67,-1.67 -4.4,-1.68 -6.08,-0.01 v 0 c -0.82,0.81 -2.14,0.81 -2.96,-0.01 l -7.12,-7.16 c -1.08,-1.08 -1.24,-2.77 -0.39,-4.04 14.18,-21.47 11.79,-50.68 -7.07,-69.62 v 0 c -21.65,-21.59 -56.48,-21.8 -78.24,-0.59 -21.68,21.14 -22.32,56.22 -1.38,78.1 10.57,11.04 24.84,17.11 39.99,17.15 10.92,0.03 21.42,-3.17 30.35,-8.95 1.3,-0.84 3,-0.66 4.09,0.43 l 7.1,7.13 c 0.81,0.82 0.81,2.14 -0.01,2.96 v 0 c -1.67,1.67 -1.68,4.4 -0.01,6.08 l 35.88,36.04 c 1.67,1.67 4.4,1.68 6.08,0.01 l 15.64,-15.56 c 1.81,-1.48 1.82,-4.11 0.01,-5.92 z m -99.08,-39.8 c -10.18,-0.02 -19.7,-3.99 -26.74,-11.23 -14.74,-14.81 -14.69,-38.95 0.12,-53.69 7.41,-7.37 17.1,-11.13 26.79,-11.1 9.69,0.02 19.37,3.82 26.74,11.23 14.74,14.81 14.69,38.95 -0.12,53.69 -7.08,7.2 -16.61,11.12 -26.79,11.1 z"
        style={{ fill: '#ffffff' }}
      />
    </g>
  </svg>
);

export const CloudPrintIcon: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill="#808080"
      d="M15 15H9v-1h6v1m0 1H9v1h6v-1m0 2H9v1h6v-1m8-4.5c0 1.25-.44 2.31-1.31 3.19c-.88.87-1.94 1.31-3.19 1.31H18v4H6v-4.05c-1.3-.1-2.43-.59-3.39-1.52C1.54 15.38 1 14.09 1 12.58c0-1.3.39-2.46 1.17-3.48S4 7.43 5.25 7.15c.42-1.53 1.25-2.77 2.5-3.72S10.42 2 12 2c1.95 0 3.6.68 4.96 2.04C18.32 5.4 19 7.05 19 9c1.15.13 2.1.63 2.86 1.5c.76.85 1.14 1.85 1.14 3M6 15.95V11h11V9c0-1.38-.5-2.56-1.46-3.54C14.56 4.5 13.38 4 12 4s-2.56.5-3.54 1.46C7.5 6.44 7 7.62 7 9h-.5c-.97 0-1.79.34-2.47 1.03c-.69.68-1.03 1.5-1.03 2.47s.34 1.79 1.03 2.5c.56.54 1.22.85 1.97.95M16 13H8v7h8v-7m5 .5c0-.7-.24-1.29-.73-1.77S19.2 11 18.5 11H18v5h.5c.7 0 1.29-.24 1.77-.72S21 14.2 21 13.5Z"
    />
  </svg>
);

export const CertaraLogo: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 792.99997 202.276"
    width={size}
    height={size}
    {...props}
  >
    <g transform="translate(-665.066,-0.862)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="m 688.768,109.06 v 0 c 0,17.67 12.216,32.676 29.886,32.676 11.771,0 18.985,-4.709 27.086,-12.074 l 14.428,14.579 c -10.607,11.335 -22.379,18.4 -42.252,18.4 -30.329,0 -52.85,-23.987 -52.85,-53.579 0,-29.592 22.521,-53.579 52.85,-53.579 19.873,0 31.645,7.063 42.252,18.4 L 745.74,88.458 c -8.1,-7.364 -15.315,-12.073 -27.086,-12.073 -17.67,0 -29.886,15.006 -29.886,32.675"
                fill="#e71618"
              />
              <path
                d="M 1440.737,20.305 A 54.649,54.649 0 0 0 1401.451,3.758 c -28.285,0 -51.292,23.292 -51.292,51.92 0,0.712 0.017,1.425 0.042,2.128 h 18.248 c -0.05,-0.7 -0.075,-1.416 -0.075,-2.128 0,-18.616 14.812,-33.705 33.077,-33.705 20.535,0 37.174,16.957 37.174,37.869 a 42.633,42.633 0 0 1 -22.948,38 l 7,16.89 a 60.056,60.056 0 0 0 16.715,-12.039 60.784,60.784 0 0 0 17.452,-42.847 56.123,56.123 0 0 0 -16.1,-39.537"
                fill="#e71618"
              />
            </g>
            <path
              d="M 773.177,58.387 H 850.96 V 78.57 h -55.246 v 20.912 h 48.611 v 20.183 h -48.611 v 21.658 h 55.975 v 20.183 h -78.512 z"
              fill="#e71618"
            />
            <g>
              <path
                d="m 915.035,108.472 c 11.051,0 17.376,-5.89 17.376,-14.578 v -0.3 c 0,-9.718 -6.778,-14.729 -17.82,-14.729 h -22.538 v 29.609 z m -45.67,-50.085 h 47.144 c 13.112,0 23.275,3.686 30.053,10.456 5.748,5.748 8.831,13.849 8.831,23.576 V 92.7 c 0,16.656 -8.982,27.121 -22.094,31.972 l 25.194,36.831 h -26.517 l -22.1,-32.994 h -17.823 v 32.994 h -22.688 z"
                fill="#e71618"
              />
              <path
                d="m 1201.11,108.472 c 11.051,0 17.385,-5.89 17.385,-14.578 v -0.3 c 0,-9.718 -6.778,-14.729 -17.829,-14.729 h -22.537 v 29.609 z m -45.661,-50.085 h 47.136 c 13.12,0 23.275,3.686 30.053,10.456 5.747,5.748 8.839,13.849 8.839,23.576 V 92.7 c 0,16.656 -8.99,27.121 -22.1,31.972 l 25.193,36.831 h -26.517 l -22.1,-32.994 h -17.82 v 32.994 h -22.68 z"
                fill="#e71618"
              />
            </g>
            <path
              d="m 1017.97,79.3 h 31.536 V 58.424 H 963.712 V 79.3 h 31.569 v 82.21 h 22.789 l -0.1,-28.98 z"
              fill="#e71618"
            />
            <path
              d="m 1279.915,118.343 13.7,-33.438 13.7,33.438 z m -17.535,43.164 9.442,-23.132 h 43.592 l 12.425,32.122 h 23.132 L 1303.776,57.642 h -20.912 l -34.845,82.92 z"
              fill="#e71618"
            />
            <g>
              <path
                d="m 1368.828,161.413 a 1.457,1.457 0 0 0 1.592,-1.567 1.388,1.388 0 0 0 -1.592,-1.575 h -3.016 v 3.142 z m 3.552,5.362 h -2.212 l -1.86,-3.586 h -2.5 v 3.561 h -1.936 v -10.255 h 4.927 a 3.35,3.35 0 0 1 1.39,6.468 z m -4.717,-12.5 a 7.592,7.592 0 1 0 7.474,7.583 7.536,7.536 0 0 0 -7.474,-7.583 m 0,16.908 a 9.317,9.317 0 1 1 9.334,-9.325 9.329,9.329 0 0 1 -9.334,9.325"
                fill="#e71618"
              />
              <path
                d="m 1447.765,57.809 h -18.239 c 0.05,0.7 0.075,1.416 0.075,2.128 0,18.616 -14.8,33.706 -33.077,33.706 -19.857,0 -36.027,-15.869 -37.074,-35.834 h -9.25 c -0.025,-0.712 -0.042,-1.416 -0.042,-2.137 a 52.042,52.042 0 0 1 28.629,-46.557 l -3.418,-8.253 a 60.147,60.147 0 0 0 -16.79,12.065 60.821,60.821 0 0 0 -17.444,42.846 56.069,56.069 0 0 0 16.1,39.537 54.649,54.649 0 0 0 39.286,16.547 c 28.276,0 51.291,-23.292 51.291,-51.92 0,-0.712 -0.016,-1.424 -0.05,-2.128"
                fill="#ffaa1a"
              />
            </g>
          </g>
          <path
            d="m 1106.767,118.338 -13.707,-33.429 -13.7,33.429 z M 1082.9,57.646 h 20.921 l 44.195,103.866 H 1124.3 l -9.434,-23.133 h -43.606 l -9.426,23.133 h -23.124 z"
            fill="#e71618"
          />
        </g>
      </g>
    </g>
  </svg>
);